export default string => {
    const strArr = string.replace(/[^\d\w\s]+/g, "").split(" ");
    const snakeArr = strArr.reduce((acc, val) => {
        return acc.concat(val.toLowerCase());
    }, []);

    return snakeArr.join("_");
}